import React from 'react';
import { Routes, Route } from 'react-router-dom';

import { Home } from './pages/Home';
import { Checkout } from './pages/Checkout';

export const AppRouter = () => (
  <Routes>
    <Route index element={<Home />} />
    <Route path="/checkout" element={<Checkout />} />
  </Routes>
);
